var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata_box"},[_c('img',{staticClass:"icon",attrs:{"src":_vm.img,"alt":""}}),_c('p',[_vm._v("这里空空如也～")])])
}
var staticRenderFns = []

export { render, staticRenderFns }